import { EVENTS } from '../../bus/events.const';
import { COMPONENTS } from '../../components';
import { RecommendationsParentModuleKey, SLOTS } from '../../models';
import { WIRES } from '../../wiring';
import { AppBuilder } from '../app.builder';

export function enableDiscoveryWall(appBuilder: AppBuilder): void {
  appBuilder
    .replaceWireInEvent(WIRES.getAllDiscoveryWallRecommendations, EVENTS.OpenEmpathyX, WIRES.getEmptySearchRecommendations)
    .setConfigFor('mobile', configBuilder =>
      configBuilder.setCoreConfig({
        components: {
          EmptySearch: {
            children: {
              Recommendations: null,
              DiscoveryWall: {
                component: COMPONENTS.SMART.DiscoveryWall,
                children: {
                  Recommendations: {
                    component: COMPONENTS.SMART.Recommendations,
                    data: {
                      slot: SLOTS.discoveryWall.recommendationsFallback,
                      props: {
                        type: RecommendationsParentModuleKey.emptySearch
                      }
                    }
                  }
                }
              }
            }
          }
        }
      })
    );
}
